import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/services/user/user.service';
import { User } from 'src/classes/user';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AuthenticationService } from 'src/services/authentication/authentication.service';

@Component({
  selector: 'app-account-page',
  templateUrl: './account-page.component.html',
  styleUrls: ['./account-page.component.scss']
})
export class AccountPageComponent implements OnInit {

  public isSavingPersonalDetails = false;
  public editingPersonalDetails = false;
  public isSavingEmailConfiguration = false;
  public editingEmailConfiguration = false;
  public error?: Error;
  public formErrors: string[] = [];
  public user?: User;
  private paramIdRecord: Record<string, number> = {};

  constructor(
    private userService: UserService,
    private auth: AuthenticationService
  ) {}

  ngOnInit() {
    this.updateUserData().catch(this.applyError.bind(this));
  }

  async onSavePersonalDetailsRequest(parameters: {idParam: number, value: string, key: string}[]) {
    if (parameters.length === 0) {
      this.disablePersonalDetailsForm();
      return;
    }
    this.isSavingPersonalDetails = true;
    try {
      if (this.formErrors.length === 0) {
        await this.userService.patchParams(parameters);
        this.updateNameFromParams(parameters);
        this.updateUserFromParams(parameters);
        this.disablePersonalDetailsForm();
      }
    } catch (err) {
      console.error(err);
      this.formErrors = err.message.split('\n');
    }
    this.isSavingPersonalDetails = false;
  }

  async onSaveEmailConfigurationRequest(parameters: {idParam: number, value: string, key: string}[]) {
    if (parameters.length === 0) {
      this.disableEmailConfigurationForm();
      return;
    }
    this.isSavingEmailConfiguration = true;
    try {
      if (this.formErrors.length === 0) {
        console.log(parameters);
        await this.userService.patchParams(parameters);
        this.updateUserFromParams(parameters);
        console.log(this.user.paramValues);
        this.disableEmailConfigurationForm();
      }
    } catch (err) {
      console.error(err);
      this.formErrors.concat(err.message.split('\n'));
    }
    this.isSavingEmailConfiguration = false;
  }

  private applyError(err: any) {
    if (!err) {
      this.error = null;
    }
    if (err instanceof Error) {
      this.error = err;
    }
    this.error = new Error(err);
  }

  private async updateUserData() {
    if (this.user) {
      this.user = undefined;
    }
    this.user = await this.fetchUserDetails();
  }

  private async fetchUserDetails() {
    return await this.userService.get();
  }

  onEditPersonalDetailsClick() {
    this.enablePersonalDetailsForm();
  }

  onClosePersonalDetailsClick() {
    this.disablePersonalDetailsForm();
  }

  disablePersonalDetailsForm() {
    window.setTimeout(() => {
      this.editingPersonalDetails = false;
      this.formErrors = [];
      this.isSavingPersonalDetails = false;
    }, 100);
  }

  enablePersonalDetailsForm() {
    this.editingPersonalDetails = true;
    this.formErrors = [];
    this.isSavingPersonalDetails = false;
  }

  onEditEmailConfigurationClick() {
    this.enableEmailConfigurationForm();
  }

  onCloseEmailConfigurationClick() {
    this.disableEmailConfigurationForm();
  }

  disableEmailConfigurationForm() {
    window.setTimeout(() => {
      this.editingEmailConfiguration = false;
      this.formErrors = [];
      this.isSavingEmailConfiguration = false;
    }, 100);
  }

  enableEmailConfigurationForm() {
    this.editingEmailConfiguration = true;
    this.formErrors = [];
    this.isSavingEmailConfiguration = false;
  }

  updateUserFromParams(parameters: {value: string, key: string}[]) {
    for (let param of parameters) {
      if (!this.user || !this.user.paramValues) {
        break;
      }
      this.user.paramValues[param.key] = param.value;
    }
  }

  updateNameFromParams(parameters: {value: string, key: string}[]) {
    let firstName: string;
    let lastName: string;
    for (let param of parameters) {
      if (!this.user || !this.user.paramValues) {
        break;
      }
      if (param.key === 'firstName') {
        firstName = param.value;
      } else if (param.key === 'lastName') {
        lastName = param.value;
      }
    }
    // Check if first name or last name has been changed
    if (!firstName && !lastName) {
      // If they haven't, no need to update
      return;
    }
    // Coalesce the missing parameters so that if one is changed and the other the new full name isn't incomplete
    if (!firstName) {
      firstName = this.user.paramValues.firstName;
    }
    if (!lastName) {
      lastName = this.user.paramValues.lastName;
    }
    const fullName = `${firstName} ${lastName}`.trim();

    this.auth.updateName(fullName);
  }
}
